import { useForm } from "react-hook-form";
import Box from "../../../shared/box/Box";
import Input from "../../../shared/input";
import { IProfile } from "../../../interfaces/customer-experience-assistant/IProfile";
import Button from "../../../shared/button";
import { useCreateHotelLocationMutation } from "../../../store/customer-experience/customerExperienceApi";
import { useGetCurrentUserQuery } from "../../../store/user/userApi";

const AddHotel = ({
	setActive
}: {
	setActive?: (active: "profile" | "hotels" | "add-hotel") => void
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IProfile>();
  const { data: user } = useGetCurrentUserQuery();
  const [createHotelLocation, { isLoading }] = useCreateHotelLocationMutation();

  const onSubmit = async (data: IProfile) => {
    console.log({ data });
    try {
      await createHotelLocation({...data, userId: user?.id || ''}).unwrap();
	  setActive && setActive('hotels')
    } catch (e) {
      console.log({ e });
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="my-3 py-3 border-t">
      <Box title="Add Hotel">
        <div className="w-full flex flex-wrap -mx-2">
          <Input
            label="Name"
            dataQa={"name"}
            containerStyle="w-full md:w-6/12 px-2"
            register={register("hotelName", {
              required: {
                message: "Hotel name is required",
                value: true,
              },
              validate: (value: string) =>
                !!value.trim() || "Hotel name is required",
            })}
            error={errors.hotelName?.message}
          />
          <Input
            label="Location code"
            dataQa="locationCode"
            containerStyle="w-full md:w-6/12 px-2"
            register={register("locationCode", {
              required: {
                message: "Location code is required",
                value: true,
              },
              validate: (value: string) =>
                !!value.trim() || "Location code is required",
            })}
            error={errors.locationCode?.message}
          />
          <Input
            label="Description"
            dataQa="description"
            containerStyle="w-full md:w-6/12 px-2"
            register={register("description", {
              required: {
                message: "Description is required",
                value: true,
              },
              validate: (value: string) =>
                !!value.trim() || "Description is required",
            })}
            error={errors.description?.message}
          />
          <Input
            label="Timezone"
            dataQa="timezone"
            containerStyle="w-full md:w-6/12 px-2"
            register={register("timezone", {
              required: {
                message: "Timezone is required",
                value: true,
              },
              validate: (value: string) =>
                !!value.trim() || "Timezone is required",
            })}
            error={errors.timezone?.message}
          />
          <Input
            label="Address Line 1"
            dataQa="addressLine1"
            containerStyle="w-full md:w-4/12 px-2"
            register={register("address.addressLine1", {
              required: {
                message: "Address line 1 is required",
                value: true,
              },
              validate: (value: string) =>
                !!value.trim() || "Address line 1 is required",
            })}
            error={errors.address?.addressLine1?.message}
          />
          <Input
            label="Address Line 2"
            dataQa="addressLine2"
            containerStyle="w-full md:w-4/12 px-2"
            register={register("address.addressLine2")}
            error={errors.address?.addressLine2?.message}
          />
          <Input
            label="City"
            dataQa="city"
            containerStyle="w-full md:w-4/12 px-2"
            register={register("address.city", {
              required: {
                message: "City is required",
                value: true,
              },
              validate: (value: string) => !!value.trim() || "City is required",
            })}
            error={errors.address?.city?.message}
          />
          <Input
            label="State"
            dataQa="state"
            containerStyle="w-full md:w-4/12 px-2"
            register={register("address.state")}
            error={errors.address?.state?.message}
          />
          <Input
            label="Zip"
            dataQa="zip"
            containerStyle="w-full md:w-4/12 px-2"
            register={register("address.zip", {
              required: {
                message: "Zip is required",
                value: true,
              },
              validate: (value: string) => !!value.trim() || "Zip is required",
            })}
            error={errors.address?.zip?.message}
          />
          <Input
            label="Country"
            dataQa="country"
            containerStyle="w-full md:w-4/12 px-2"
            register={register("address.country", {
              required: {
                message: "Country is required",
                value: true,
              },
              validate: (value: string) =>
                !!value.trim() || "Country is required",
            })}
            error={errors.address?.country?.message}
          />
          <Button
            loading={isLoading}
            className="w-full bg-saloon-btn hover:bg-opacity-80 p-3 text-saloon-primary rounded-3xl font-semibold text-base mt-8"
            type="submit"
            label={<>Create Hotel</>}
          />
        </div>
      </Box>
    </form>
  );
};

export default AddHotel;
